module.exports = __webpack_public_path__ + "media/images/gallery/stars/hearit-00a9c9cde483a13bc1976055437c9e31.gif";